import { BoardData } from './board-types.ts';

export const DEFAULT_BOARD_DATA: BoardData = {
    rows: [[
        {
            label: 'Battlefield',
            size: 6,
            kind: 'spread',
            visibility: 'public',
            autoFlip: null,
            isDeck: false,
        }, {
            label: 'Stack',
            size: 2,
            kind: 'spread',
            visibility: 'public',
            autoFlip: null,
            isDeck: false,
        }, {
            label: 'Hero',
            size: 1,
            kind: 'spread',
            visibility: 'public',
            autoFlip: null,
            isDeck: false,
        }
    ], [
        {
            label: 'Hand',
            size: 6,
            kind: 'spread',
            visibility: 'private',
            autoFlip: 'front',
            isDeck: false,
        }, {
            label: 'Deck',
            size: 1,
            kind: 'stack',
            visibility: 'public',
            autoFlip: 'back',
            isDeck: true,
        }, {
            label: 'Graveyard',
            size: 1,
            kind: 'stack',
            visibility: 'public',
            autoFlip: 'front',
            isDeck: false,
        }, {
            label: 'Exile',
            size: 1,
            kind: 'stack',
            visibility: 'public',
            autoFlip: 'front',
            isDeck: false,
        }
    ]]
};

export const TOOLTIP_SHOW_DELAY = 500;
export const TOOLTIP_HIDE_DELAY = 100;
export const TOOLTIP_QUICK_SHOW_DELAY = 500;